// extracted by mini-css-extract-plugin
export default {"colorIcon":"ColorIcon_colorIcon__2fJk8","blue":"ColorIcon_blue__fVWyu","green":"ColorIcon_green__HAEGw","red":"ColorIcon_red__HU84i","yellow":"ColorIcon_yellow__27C-3"};